module.exports = {"id":"231281","name":"Trent Alexander-Arnold","rating":"73","photo":"./data/images/photos/4/231281.png","club":{"name":"Liverpool","logo":"./data/images/clubs/Liverpool.png"},"positions":["DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TrentAlexander-Arnold0.json
// module id = 4197
// module chunks = 0